export default "__VITE_ASSET__CrRsMWFF__"